window.addEventListener('load', () => {
  const itemTabs = document.querySelectorAll('.side-by-side__item .side-by-side__buttons .side-by-side__button');
  const itemContent = document.querySelectorAll('.side-by-side__item .side-by-side__img');
  
  if (itemTabs.length && itemContent.length) {
    itemTabs.forEach((ele, index) => {
      ele.setAttribute('data-count', index);
      ele.addEventListener('click', function(e) {
        e.preventDefault();

        // Remove active class from all siblings efficiently
        this.parentNode.querySelectorAll('.side-by-side__button').forEach((sibling) => {
          sibling.classList.remove('active');
        });

        this.classList.add('active');
        const eleVal = this.getAttribute("data-count");

        // Find image with matching data-count attribute using closest ancestor
        const itemWithAttribute = this.closest('.side-by-side__item').querySelector(`.side-by-side__img[data-count="${eleVal}"]`);

        // Remove active class from all images within the same item efficiently
        itemWithAttribute.parentNode.querySelectorAll('.side-by-side__img').forEach((sibling) => {
          sibling.classList.remove('active');
        });

        itemWithAttribute.classList.add('active');
      });

      // Set data-count only if corresponding content exists (optional)
      if (itemContent[index]) {
        itemContent[index].setAttribute('data-count', index);
      }
    });
  }
});
